import { create } from "zustand";
import {
  activeStatus,
  segmentData,
  search,
  segmentIdDetail,
  editSegment,
  removeSegment,
  segmentContent,
} from "../api_layer/api";

export const useManageSegmentStore = create((set) => ({
  segmentData: [],
  segmentDetailData: [],
  editSegmentData: [],
  removeSegmentData: [],
  segmentContentData: [],
  segmentLoading: false,
  segmentDetailLoading: false,
  segmentComponentLoading: false,
  editSegmentLoading: false,
  statusLoading: false,
  removeSegmentLoading: false,
  error: null,
  fetchSegmentData: async (page, keyword) => {
    try {
      set({ segmentLoading: true, error: null });
      const response = await segmentData(page, keyword);
      set({ segmentData: response.data, segmentLoading: false });
    } catch (error) {
      set({ error: error.message, segmentLoading: false });
    }
  },
  updateActiveStatus: async (id, setToaster, active, fetchSegmentData, searchText, newPage) => {
    try {
      set({ statusLoading: true, error: null });
      const response = await activeStatus(id, active);
      if (searchText) {
        const keyword = `keyword=${searchText}&`;
        fetchSegmentData(0, keyword);
      } else {
        fetchSegmentData(0, "");
      }
      newPage(1);
      setToaster("Status", "Status has been changed", "success");
      set({ statusLoading: false });
    } catch (error) {
      setToaster("Status", "Status Update failed", "danger");
      set({ error: error.message, statusLoading: false });
    }
  },
  fetchSegmentDetail: async (id) => {
    try {
      set({ segmentDetailLoading: true, error: null });
      const response = await segmentIdDetail(id);
      set({ segmentDetailData: response.data, segmentDetailLoading: false });
    } catch (error) {
      set({ error: error.message, segmentDetailLoading: false });
    }
  },
  updateEditSegment: async (id, payload,setToaster, fetchSegmentData, searchText,setModalShow) => {
    try {
      set({ editSegmentLoading: true, error: null });
      const response = await editSegment(id, payload);
      if (searchText) {
        const keyword = `keyword=${searchText}&`;
        fetchSegmentData(0, keyword);
      } else {
        fetchSegmentData(0, "");
      }
      setModalShow(false);
      setToaster("Segment", "Segment saved successfully", "success");
      set({ editSegmentData: response.data, editSegmentLoading: false });
    } catch (error) {
      setToaster("Segment", "Segment save failed", "danger");
      set({ error: error.message, editSegmentLoading: false });
    }
  },
  deleteSegment: async (id, setToaster, fetchSegmentData, searchText, newPage) => {
    try {
      set({ removeSegmentLoading: true, error: null });
      const response = await removeSegment(id);
      set({ removeSegmentData: response.data, removeSegmentLoading: false });
      if (searchText) {
        const keyword = `keyword=${searchText}&`;
        fetchSegmentData(0, keyword);
      } else {
        fetchSegmentData(0, "");
      }
      newPage(1);
      setToaster("Segment", "Segment deleted successfully", "success");
    } catch (error) {
      setToaster("Segment", "Segment deletion failed ", "danger");
      set({ error: error.message, removeSegmentLoading: false });
    }
  },
  fetchSegmentContent: async (id) => {
    try {
      set({ segmentComponentLoading: true, error: null });
      const response = await segmentContent(id);
      set({
        segmentContentData: response.data,
        segmentComponentLoading: false,
      });
    } catch (error) {
      set({ error: error.message, segmentComponentLoading: false });
    }
  },
}));
